/* eslint-disable */
// @ts-nocheck

const fpsLogger = {
    timer: null,
    _fps: 0,
    currentTime: 0,
    preFrameTimeStamp: 0,
    // fps
    fpsArr: [],
    // 每帧耗时
    durationArr: [],
    averageFPS: 0,
    stopTimer: null,
    started: false,

    start() {
        const init = () => {
            if (!fpsLogger.started) {
                fpsLogger.preFrameTimeStamp = Date.now();
                fpsLogger.tick();
                fpsLogger.started = true;
            }
            if (fpsLogger.stopTimer) {
                clearTimeout(fpsLogger.stopTimer);
            }
            fpsLogger.stopTimer = setTimeout(() => {
                fpsLogger.stop();
                fpsLogger.stopTimer = null;
                // 检查当前保存的数据量，太多了就清除
                if (fpsLogger.fpsArr.length > 200) {
                    fpsLogger.fpsArr.length = 0;
                    fpsLogger.durationArr.length = 0;
                }
            }, 2000);
        };
        document.addEventListener('keydown', init);
        document.addEventListener('click', init);
    },

    tick() {
        fpsLogger._fps++;
        fpsLogger.currentTime = Date.now();
        if (fpsLogger.currentTime - fpsLogger.preFrameTimeStamp >= 1000) {
            // 帧率数据
            fpsLogger.fpsArr.push(fpsLogger._fps);
            // 每帧耗时数据
            fpsLogger.durationArr.push(1000 / fpsLogger._fps);
            fpsLogger._fps = 0;
            fpsLogger.preFrameTimeStamp = fpsLogger.currentTime;
        }
        fpsLogger.timer = requestAnimationFrame(fpsLogger.tick);
    },

    /**
     * 计算平均FPS值
     *
     */
    calcAverageFPS() {
        let sum = 0;
        for (let i = 0; i < fpsLogger.fpsArr.length; i++) {
            sum += fpsLogger.fpsArr[i];
        }
        fpsLogger.averageFPS = Math.round(sum / fpsLogger.fpsArr.length);
        fpsLogger.fpsArr = [];
    },

    /**
     * 获取平均FPS值
     *
     * @return {number} fps
     */
    getAverageFPS() {
        if (fpsLogger.averageFPS === 0) {
            fpsLogger.calcAverageFPS();
        }
        return fpsLogger.averageFPS;
    },

    /**
     * 停止记录
     */
    stop: function () {
        if (fpsLogger.timer) {
            cancelAnimationFrame(fpsLogger.timer);
            fpsLogger.timer = null;
        }
        fpsLogger.started = false;
    },
};

export default fpsLogger;
